import { createElement } from 'react';
import { Redirect } from 'react-resource-router';
import { AppUpdatesListPage } from '@app/app-updates';
import { ROUTES } from '@app/navigation';
import { AppUpdatesDetailsPage } from '../../app-details';

export const appUpdatesListRoute = {
  name: 'app-updates',
  path: '/release-notes',
  exact: true,
  component: AppUpdatesListPage,
  resources: [],
};

export const appUpdatesBundledChangesRoute = {
  name: 'app-updates-bundled-changes',
  path: ROUTES.RELEASE_TRACKS_CHANGES,
  exact: true,
  component: AppUpdatesListPage,
  resources: [],
};

export const appUpdatesLegacyBundledChangesRoute = {
  name: 'app-updates-legacy-bundled-changes',
  path: ROUTES.LEGACY_BUNDLED_CHANGES,
  exact: true,
  component: () =>
    createElement(Redirect, { to: ROUTES.RELEASE_TRACKS_CHANGES }),
  resources: [],
};

export const appUpdatesDetailsRoute = {
  name: 'app-updates-details',
  path: '/release-notes/:id',
  exact: true,
  component: AppUpdatesDetailsPage,
  resources: [],
};
